/**
 * Sountsou 2026 - Observateur de défilement moderne (Scroll Observer)
 * Détecte l'entrée des éléments .js-scroll-animate dans le viewport via IntersectionObserver natif.
 * Déclenche les animations CSS GPU avec la classe .is-in-view, puis stoppe l'observation (unobserve).
 * Zéro dépendance externe, performance 60fps optimale.
 */

export function initScrollObserver(root = document) {
    const animatedElements = Array.from(root.querySelectorAll('.js-scroll-animate'));

    if (!animatedElements.length) {
        return;
    }

    // Si l'utilisateur a configuré la réduction des mouvements, afficher immédiatement sans animation
    const prefersReducedMotion = typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        animatedElements.forEach((el) => {
            el.classList.add('is-in-view');
        });
        return;
    }

    const observerOptions = {
        root: null,
        // Déclenche quand l'élément commence à entrer confortablement dans la vue
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.08,
    };

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-in-view');
                // Désabonnement immédiat : libère le thread et garantit un coût CPU nul après déclenchement
                obs.unobserve(entry.target);
            }
        });
    }, observerOptions);

    animatedElements.forEach((el) => {
        // Évite la double initialisation si appelée plusieurs fois
        if (el.dataset.scrollObserverInit === 'true') {
            return;
        }
        el.dataset.scrollObserverInit = 'true';
        observer.observe(el);
    });
}
